import { IFieldConfiguration } from '@models/FieldConfiguration.model';

/** Drop-in utility to include "createdAt" in date check on fieldName */
export function hasDateName(
  fieldName: NonNullable<IFieldConfiguration['fieldName']>,
) {
  // Handle CreatedAt
  if (fieldName === 'createdAt') return true;
  // Handle Regular Cases
  return fieldName.includes('Date');
}
